export const ARCHIVE_QUERY_PARAM = 'archive';

/**
 * Appends `archive=1` to the url (respecting an already present query string) when archive mode is on.
 */
export const withArchive = (url: string, archive?: boolean): string => {
    if (!archive) {
        return url;
    }
    const hashIndex = url.indexOf('#');
    const base = hashIndex === -1 ? url : url.slice(0, hashIndex);
    const hash = hashIndex === -1 ? '' : url.slice(hashIndex);
    if (/[?&]archive=/.test(base)) {
        return url;
    }
    const separator = base.includes('?') ? (/[?&]$/.test(base) ? '' : '&') : '?';
    return `${base}${separator}${ARCHIVE_QUERY_PARAM}=1${hash}`;
};

/** Reads archive flag from a location search string (e.g. `?archive=1`). */
export const isArchiveSearch = (search: string): boolean => new URLSearchParams(search).get(ARCHIVE_QUERY_PARAM) === '1';
